import { AccordionPanel, Box } from '@chakra-ui/react'

export const PACSSourceNotSet = () => (
  <AccordionPanel bgColor='transparent' borderTop='1px solid #eaedf3' p='0'>
    <Box px='4' py='6' textAlign='center'>
      Credentials have not been set for this PACS Source.
    </Box>
  </AccordionPanel>
)
